import styled, { css } from 'styled-components';
import tinycolor from 'tinycolor2';
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider';
const getContainerWidth = ({ $fullwidth }) => {
    if ($fullwidth) {
        return '100%';
    }
};
const getContainerHeight = ({ $size }) => {
    if ($size === 'xsmall') {
        return 'var(--space-800)';
    }
    if ($size === 'small') {
        return 'var(--space-1000)';
    }
    if ($size === 'medium') {
        return 'var(--space-1200)';
    }
    if ($size === 'large') {
        return 'var(--space-1400)';
    }
};
const getContainerHorizontalPadding = ({ $size }) => {
    if ($size === 'xsmall') {
        return 'var(--space-250)';
    }
    if ($size === 'small') {
        return 'var(--space-400)';
    }
    if ($size === 'medium') {
        return 'var(--space-500)';
    }
    if ($size === 'large') {
        return 'var(--space-600)';
    }
};
const getContainerBackground = ({ $appearance, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorPrimary)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.colorPrimary;
    }
    if ($appearance === 'primary') {
        return 'var(--bg-brand)';
    }
    if ($appearance === 'primary-inverted') {
        return 'var(--bg-primary-invert)';
    }
    if ($appearance === 'secondary' && ((_f = (_e = theme.automated) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.buttonBackground)) {
        return (_g = theme.automated) === null || _g === void 0 ? void 0 : _g.styles.buttonBackground;
    }
    if ($appearance === 'secondary') {
        return 'var(--bg-secondary)';
    }
    if ($appearance === 'destructive') {
        return 'var(--bg-critical)';
    }
    if ($appearance === 'destructive-inverted') {
        return 'var(--bg-primary)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--bg-transparent)';
    }
};
const getContainerColor = ({ $appearance, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnPrimary)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.colorOnPrimary;
    }
    if ($appearance === 'primary') {
        return 'var(--text-on-brand)';
    }
    if ($appearance === 'primary-inverted') {
        return 'var(--text-primary-invert)';
    }
    if ($appearance === 'secondary' && ((_f = (_e = theme.automated) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.colorOnBackground)) {
        return (_g = theme.automated) === null || _g === void 0 ? void 0 : _g.styles.colorOnBackground;
    }
    if ($appearance === 'secondary') {
        return 'var(--text-primary)';
    }
    if ($appearance === 'destructive') {
        return 'var(--text-on-brand)';
    }
    if ($appearance === 'destructive-inverted') {
        return 'var(--text-critical)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--text-primary)';
    }
};
const getContainerHoverBackground = ({ $appearance, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.palePrimaryLight)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.palePrimaryLight;
    }
    if ($appearance === 'primary') {
        return 'var(--bg-brand-hover)';
    }
    if ($appearance === 'primary-inverted') {
        return 'color-mix(in oklab, var(--bg-primary-invert) 80%, transparent)';
    }
    if ($appearance === 'secondary' && ((_f = (_e = theme.automated) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.buttonBackgroundHover)) {
        return (_g = theme.automated) === null || _g === void 0 ? void 0 : _g.styles.buttonBackgroundHover;
    }
    if ($appearance === 'secondary') {
        return 'var(--bg-secondary-hover)';
    }
    if ($appearance === 'destructive') {
        return 'var(--bg-critical-hover)';
    }
    if ($appearance === 'destructive-inverted') {
        return 'var(--bg-secondary-hover)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--bg-transparent-strong)';
    }
};
const getContainerActiveBackground = ({ $appearance, theme }) => {
    var _a, _b, _c, _d;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.palePrimaryLight)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.palePrimaryLight;
    }
    if ($appearance === 'primary') {
        return 'var(--bg-brand-active)';
    }
    if ($appearance === 'primary-inverted') {
        return 'var(--bg-primary-invert)';
    }
    if ($appearance === 'secondary') {
        return 'var(--text-primary)';
    }
    if ($appearance === 'destructive') {
        return 'var(--bg-critical-active)';
    }
    if ($appearance === 'destructive-inverted') {
        return 'var(--bg-secondary-hover)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--bg-transparent-strongest)';
    }
};
const getContainerActiveColor = ({ $appearance }) => {
    if ($appearance === 'secondary') {
        return 'var(--text-primary-invert)';
    }
};
const getContainerFocusBackground = ({ $appearance, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorPrimary)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.colorPrimary;
    }
    if ($appearance === 'primary') {
        return 'var(--bg-brand)';
    }
    if ($appearance === 'primary-inverted') {
        return 'var(--bg-primary-invert)';
    }
    if ($appearance === 'secondary' && ((_f = (_e = theme.automated) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.colorOnBackground)) {
        return tinycolor
            .mix((_g = theme.automated) === null || _g === void 0 ? void 0 : _g.styles.colorBackground, (_h = theme.automated) === null || _h === void 0 ? void 0 : _h.styles.colorOnBackground, 10)
            .toHexString();
    }
    if ($appearance === 'secondary') {
        return 'var(--bg-secondary)';
    }
    if ($appearance === 'destructive') {
        return 'var(--bg-critical)';
    }
    if ($appearance === 'destructive-inverted') {
        return 'var(--bg-primary)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--bg-transparent)';
    }
};
const getContainerFocusColor = ({ $appearance, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnPrimary)) {
        return (_d = (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.colorOnPrimary;
    }
    if ($appearance === 'primary-inverted') {
        return 'var(--text-primary-invert)';
    }
    if ($appearance === 'secondary' && ((_f = (_e = theme.automated) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.colorOnBackground)) {
        return (_h = (_g = theme.automated) === null || _g === void 0 ? void 0 : _g.styles) === null || _h === void 0 ? void 0 : _h.colorOnBackground;
    }
    if ($appearance === 'secondary') {
        return 'var(--text-primary)';
    }
    if ($appearance === 'semi-transparent') {
        return 'var(--text-primary)';
    }
};
const getContainerDisabledBackground = (props) => {
    return `color-mix(in oklab, ${getContainerBackground(props)} 40%, transparent)`;
};
const getContainerDisabledColor = ({ $appearance, theme }) => {
    var _a, _b, _c, _d;
    if ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnPrimary) {
        return tinycolor
            .mix((_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles.colorBackground, (_d = theme.automated) === null || _d === void 0 ? void 0 : _d.styles.colorOnPrimary, 40)
            .toHexString();
    }
    if ($appearance === 'secondary' || $appearance === 'semi-transparent') {
        return `color-mix(in oklab, var(--text-primary) 40%, transparent)`;
    }
    return 'var(--text-on-brand)';
};
export const Container = styled.button((props) => {
    const { $loading, $multiline } = props;
    return css `
    display: flex;
    align-items: center;
    justify-content: center;

    width: ${getContainerWidth(props)};
    height: ${getContainerHeight(props)};
    padding-left: ${getContainerHorizontalPadding(props)};
    padding-right: ${getContainerHorizontalPadding(props)};
    background: ${getContainerBackground(props)};
    outline: none;
    position: relative;

    border-radius: ${getAutomatedStyleProp('buttonCornerRadius', 'var(--radius-brand)')};

    white-space: nowrap;

    font-weight: ${getAutomatedStyleProp('fontWeightBaseBold', 'var(--font-weight-semibold)')};
    text-transform: ${getAutomatedStyleProp('textTransformBase')};

    font-size: var(--font-size-400);
    font-family: var(--font-family-body);
    line-height: var(--font-line-height-400);
    color: ${getContainerColor(props)};

    ${props.$size === 'xsmall' &&
        css `
      font-size: var(--font-size-300);
      font-weight: var(--font-weight-medium);
      line-height: var(--font-line-height-300);
    `}

    appearance: none !important; // NOTE: Required for Safari.

    ${$multiline &&
        css `
      height: auto;
      min-height: ${getContainerHeight(props)};

      white-space: normal;
      word-break: break-all;
    `}
    ${!$loading &&
        css `
      &:hover {
        background: ${getContainerHoverBackground(props)};

        color: ${getContainerColor(props)};
      }

      &:active {
        background: ${getContainerActiveBackground(props)};

        color: ${getContainerActiveColor(props)};
      }

      &:focus {
        background: ${getContainerFocusBackground(props)};

        color: ${getContainerFocusColor(props)};

        &:after {
          content: '';
          position: absolute;
          padding: var(--space-50);
          border: 1px solid ${getContainerFocusBackground(props)};
          width: 100%;
          height: 100%;
          border-radius: ${getAutomatedStyleProp('buttonCornerRadius', 'var(--radius-brand)')};
        }
      }
    `}
    &:disabled {
      cursor: not-allowed;

      ${!$loading &&
        css `
        background: ${getContainerDisabledBackground(props)};
        color: ${getContainerDisabledColor(props)};
      `}
    }

    &:focus-visible {
      outline-offset: var(--space-50);
      outline: ${getContainerBackground(props)} solid var(--space-50);
    }
  `;
});
export const IconContainer = styled.div `
  display: flex;
  align-self: center;

  ${({ color }) => color &&
    css `
      color: ${color};
    `}

  + span {
    padding-left: var(--space-250);
  }
`;
export const Label = styled.span `
  display: flex;

  > span + ${IconContainer} {
    padding-left: var(--space-250);
  }

  ${({ $loading }) => $loading &&
    css `
      visibility: hidden;
    `}
`;
export const LoaderContainer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map